import { useState } from "react";
import PageHeading from "../components/PageHeading";
import CommercialPage from "./CommercialPage";

export default function GestionActivitePage() {
  const [headerActionsTarget, setHeaderActionsTarget] = useState(null);
  return (
    <div>
      <div className="mb-6 flex flex-wrap items-center justify-between gap-4">
        <PageHeading
          icon="activity"
          title={<> Actions et tâches </>}
          description={
            <>
              {" "}
              Retrouvez vos tâches dans Ma journée et organisez votre suivi
              commercial.{" "}
            </>
          }
        />
        <div ref={setHeaderActionsTarget} className="commercial-module" />
      </div>
      <CommercialPage
        headerActionsTarget={headerActionsTarget}
        dayContent={true}
      />
    </div>
  );
}
